import RestService from "@/services/RestService";

function getBooks() {
  const data = {};
  return RestService.sendReq("get", "books", data);
}

function geReportCard() {
  const data = {};
  return RestService.sendReq("get", "report-card", data);
}

function getStudentReportCardPreview() {
  return RestService.sendReq("get", "student/report-card/preview", {});
}

function getStudentReportCardPdf() {
  return RestService.sendReq(
    "get",
    "student/report-card/pdf",
    {},
    { responseType: "blob" }
  );
}

export default {
  getBooks,
  geReportCard,
  getStudentReportCardPreview,
  getStudentReportCardPdf,
};
